import { useCallback } from 'react';
import type {
  ReactElement,
} from 'react';

import styled from 'styled-components';

import {
  getCollapserHeight,
} from './style';

export const StyledCollapser = styled.div<{
  isCollapsed: boolean;
}>(({
  isCollapsed,

  theme,
  theme: {
    colors,
    indents,
  },
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: isCollapsed ? 'center' : 'flex-end',
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%',
  boxSizing: 'border-box',
  height: getCollapserHeight(theme),
  cursor: 'pointer',
  padding: indents.INDENT_2,
  outline: 'none',
  color: colors.ACTION_DEFAULT,

  ':hover': {
    color: colors.ACTION_HOVER,
  },

  ':active': {
    color: colors.ACTION_PRESSED,
  },
}));

export const StyledText = styled.span(({
  theme: {
    fonts,
  },
}) => ({
  ...fonts.FONT_SMALL,
  marginLeft: 4,
}));

export type MenuCollapserProps = {
  menuCollapsed: boolean;
  setMenuCollapsed: (nextValue: boolean) => void;
};

export function MenuCollapser({
  menuCollapsed,
  setMenuCollapsed: setMenuCollapsedProp,
}: MenuCollapserProps): ReactElement {
  const setMenuCollapsed = useCallback(() => {
    setMenuCollapsedProp(!menuCollapsed);
  }, [
    menuCollapsed,
    setMenuCollapsedProp,
  ]);

  return (
    <StyledCollapser
      isCollapsed={menuCollapsed}
      role="button"
      onClick={setMenuCollapsed}
      onKeyPress={setMenuCollapsed}
      tabIndex={0}
    >
      {
        menuCollapsed ? (
          <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.99984 2.66675L7.05984 3.60675L10.7798 7.33341H2.6665V8.66675H10.7798L7.05984 12.3934L7.99984 13.3334L13.3332 8.00008L7.99984 2.66675Z"
            />
          </svg>
        ) : (
          <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.3332 7.33341H5.21984L8.9465 3.60675L7.99984 2.66675L2.6665 8.00008L7.99984 13.3334L8.93984 12.3934L5.21984 8.66675H13.3332V7.33341Z"
            />
          </svg>
        )
      }

      {
        !menuCollapsed && (
          <StyledText>
            Свернуть
          </StyledText>
        )
      }
    </StyledCollapser>
  );
}
